(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v3"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.js-slideshow-v3').slick({
      autoplay: true,
      autoplaySpeed: 7000,
      dots: true,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  });

  } catch(e) { console.error(e); }
})();
})();
